function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "baguette",
  display: "none"
}, /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 3.8637,
  x1: 36.361,
  y1: 2.495,
  x2: 30.939,
  y2: 7.932
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 3.8637,
  x1: 13.892,
  y1: 2.495,
  x2: 19.314,
  y2: 7.932
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  "strokshape-filter-spane-miterlimit": 3.8637,
  x1: 13.892,
  y1: 47.703,
  x2: 19.314,
  y2: 42.266
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 3.8637,
  x1: 36.361,
  y1: 47.703,
  x2: 30.939,
  y2: 42.266
}), /*#__PURE__*/React.createElement("rect", {
  x: 13.892,
  y: 2.495,
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 3.8637,
  width: 22.469,
  height: 45.208
}), /*#__PURE__*/React.createElement("rect", {
  x: 15.69,
  y: 4.307,
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 3.8637,
  width: 18.873,
  height: 41.597
}), /*#__PURE__*/React.createElement("rect", {
  x: 17.489,
  y: 6.119,
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 3.8637,
  width: 15.277,
  height: 37.988
}), /*#__PURE__*/React.createElement("rect", {
  x: 19.286,
  y: 7.932,
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 3.8637,
  width: 11.681,
  height: 34.378
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "shield",
  display: "none"
}, /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 11.317,
  y1: 14.782,
  x2: 3.505,
  y2: 11.578
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 14.269,
  y1: 24.405,
  x2: 8.479,
  y2: 27.025
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 19.736,
  y1: 32.17,
  x2: 16.108,
  y2: 38.809
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 16.894,
  y1: 9.205,
  x2: 12.626,
  y2: 2.425
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "25.116,47.816 16.126,38.841 8.471,27.029 3.495,11.556 12.626,2.425  25.094,2.425 25.16,2.425 37.626,2.425 46.758,11.556 41.782,27.029 34.127,38.841 25.137,47.816 25.148,37.855 30.518,32.17  35.984,24.405 38.938,14.782 33.359,9.205 25.158,9.205 25.096,9.205 16.894,9.205 11.317,14.782 14.269,24.405 19.736,32.17  25.104,37.855  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "25.148,42.389 32.336,35.512 38.828,25.719 42.904,13.173 35.3,6.144  25.158,6.144 25.096,6.144 14.954,6.144 7.348,13.173 11.425,25.719 17.917,35.512 25.104,42.389  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 38.938,
  y1: 14.782,
  x2: 46.748,
  y2: 11.578
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 35.984,
  y1: 24.405,
  x2: 41.773,
  y2: 27.025
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 30.518,
  y1: 32.17,
  x2: 34.146,
  y2: 38.809
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 33.359,
  y1: 9.205,
  x2: 37.626,
  y2: 2.425
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FEFEFF",
  stroke: "#000000",
  points: "28.11,14.101 31.267,10.945  46.022,10.945 49.179,14.101 49.179,37.207 46.022,40.363 31.267,40.363 28.11,37.207  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "30.412,15.932 33.066,13.276  44.223,13.276 46.877,15.932 46.877,35.377 44.223,38.033 33.066,38.033 30.412,35.377  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "31.267,10.945 33.066,13.276  33.357,16.378 38.645,15.492 33.03,13.288  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "30.432,15.864 32.38,25.654  33.354,16.374 30.418,15.932 28.11,14.1  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "46.115,10.945 44.316,13.276  44.025,16.378 38.738,15.492 44.353,13.288  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "46.951,15.864 45.002,25.654  44.027,16.374 46.965,15.932 49.271,14.1  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "31.267,40.363 33.066,38.033  33.357,34.932 38.645,35.816 33.03,38.021  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "30.432,35.445 32.38,25.654  33.354,34.934 30.418,35.377 28.11,37.209  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "46.115,40.363 44.316,38.033  44.025,34.932 38.738,35.816 44.353,38.021  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "46.951,35.445 45.002,25.654  44.027,34.934 46.965,35.377 49.271,37.209  "
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#FEFEFF",
  stroke: "#000000",
  cx: 11.707,
  cy: 16.917,
  rx: 10.855,
  ry: 16.144
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "11.668,0.772 8.41,4.728 11.668,5.988  7.653,8.637 6.446,16.974 4.185,11.853 0.852,16.974  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "1.536,11.349 4.185,11.853 7.612,8.697  8.372,4.728 6.652,2.643  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "8.372,4.76 3.146,7.01 4.137,11.806  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "11.629,0.772 14.887,4.728 11.668,5.988  15.644,8.637 16.968,16.974 19.112,11.853 22.562,16.974  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "21.761,11.349 19.112,11.853  15.685,8.697 14.925,4.728 16.645,2.643  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "14.925,4.76 20.15,7.01 19.16,11.806  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "11.746,33.061 15.004,29.105  11.668,27.844 15.761,25.197 16.968,16.974 19.229,21.98 22.562,16.974  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "21.878,22.484 19.229,21.98  15.802,25.136 15.042,29.105 16.762,31.189  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "15.042,29.072 20.269,26.822  19.276,22.027  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "11.785,33.061 8.527,29.105  11.668,27.844 7.771,25.197 6.446,16.974 4.302,21.98 0.852,16.974  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "1.653,22.484 4.302,21.98 7.729,25.136  8.489,29.105 6.769,31.189  "
}), /*#__PURE__*/React.createElement("polyline", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#777777",
  points: "8.489,29.072 3.263,26.822 4.254,22.027  "
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#FEFEFF",
  stroke: "#000000",
  points: "35.859,48.537 4.441,48.537 20.149,21.327  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#000000",
  points: "10.814,45.854 20.151,48.537 29.67,46.191 19.599,45.259  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#777777",
  points: "35.859,48.537 30.77,44.164 28.006,34.932 21.013,28.188 20.155,29.438  19.165,27.855 12.342,34.852 9.771,44.486 4.441,48.537 10.814,45.854 19.208,27.76 20.149,21.327 21.013,28.188 29.67,46.191  35.764,48.537  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#777777",
  points: "20.155,29.438 15.144,36.521 9.771,44.486 19.599,45.259 30.77,44.164  "
}));

const SvgSpecial = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  width: "50px",
  height: "50px",
  viewBox: "0 0 50 50",
  enableBackground: "new 0 0 50 50",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpecial, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/special.9c90e1f5.svg";
export { ForwardRef as ReactComponent };